import React from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';



const VideoWidget = () => {

    function handleVideoClick(){
        (window as any).functions?.mediaLibrary?.('Videos')
    }

    return (
        <div className="widget-panel-item ">
            <WidgetButton type={WidgetType.VIDEO} onClick={handleVideoClick} />
        </div>
    )
}
export default VideoWidget